import StatusCard from './StatusCard';

export default StatusCard;
